// Custom Turbo confirmation dialog. Builds the DOM via createElement so the
// caller's `message` is set via textContent (no innerHTML interpolation, no
// XSS surface) and animation is driven by Tailwind utility classes (no
// inline style — CSP-safe).
export function showConfirmDialog(message) {
  return new Promise((resolve) => {
    // fixed-app-overlay equivalent: insets between header (3.5rem +
    // safe-area-inset-top) and bottom nav (5rem + safe-area-inset-bottom
    // on mobile, 0 on sm+). Modal must NEVER cover chrome.
    const overlay = el("div", "fixed left-0 right-0 top-[calc(3.5rem+env(safe-area-inset-top))] bottom-[calc(5rem+env(safe-area-inset-bottom))] sm:bottom-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm motion-safe:animate-fade-in")

    const card = el("div", "mx-4 w-full max-w-sm rounded-2xl bg-white dark:bg-gray-800 p-6 shadow-2xl ring-1 ring-gray-100 dark:ring-gray-700 animate-scale-in")

    const head = el("div", "flex items-start gap-3")
    const iconWrap = el("div", "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-50 dark:bg-amber-900/30")
    iconWrap.innerHTML = `<svg aria-hidden="true" class="h-5 w-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>`
    const text = el("p", "text-sm text-gray-700 dark:text-gray-300 leading-relaxed pt-2")
    text.textContent = message
    head.append(iconWrap, text)

    const actions = el("div", "mt-6 flex justify-end gap-3")
    const cancel = el("button", "rounded-full border border-gray-200 dark:border-gray-600 px-5 py-3 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer")
    cancel.type = "button"
    cancel.textContent = "Cancel"
    const confirm = el("button", "rounded-full bg-gradient-to-r from-warm-500 to-warm-600 px-5 py-3 text-sm font-semibold text-white hover:from-warm-600 hover:to-warm-700 shadow-sm transition-all cursor-pointer")
    confirm.type = "button"
    confirm.textContent = "Continue"
    actions.append(cancel, confirm)

    card.append(head, actions)
    overlay.append(card)
    overlay.setAttribute("role", "alertdialog")
    overlay.setAttribute("aria-modal", "true")
    document.body.appendChild(overlay)

    const cleanup = (result) => {
      overlay.remove()
      document.removeEventListener("keydown", onKey)
      resolve(result)
    }
    const onKey = (e) => { if (e.key === "Escape") cleanup(false) }

    cancel.addEventListener("click", () => cleanup(false))
    confirm.addEventListener("click", () => cleanup(true))
    overlay.addEventListener("click", (e) => { if (e.target === overlay) cleanup(false) })
    document.addEventListener("keydown", onKey)
    confirm.focus()
  })
}

function el(tag, className) {
  const node = document.createElement(tag)
  node.className = className
  return node
}
